import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../Slot';
import { Layout } from '../styles';

const LargeMap = ({ slot }) => {
	const { type, data, layout } = slot[0];

	return (
		<Layout>
			<Slot
				top={5}
				left={5}
				width={30}
				height={10}
				component={type}
				data={data}
				layout={layout}
			/>
			<Slot
				top={20}
				left={5}
				width={30}
				height={15}
				component={type}
				data={data}
				layout={layout}
			/>
			<Slot
				top={40}
				left={5}
				width={30}
				height={55}
				component={type}
				data={data}
				layout={layout}
			/>
			<Slot
				top={5}
				left={40}
				width={55}
				height={90}
				component={type}
				data={data}
				layout={layout}
			/>
		</Layout>
	)
}

LargeMap.defaultProps = {
	slot: []
}

LargeMap.propTypes = {
	slot: PropTypes.array,
}

export default LargeMap
